<template tag="클라이언트 버튼 컴포넌트">
  <button :type="type" :class="buttonClasses" :disabled="disabled">
    <i v-if="icon && iconPosition === 'before'" :class="[icon]"></i>
    <slot></slot>
    <i v-if="icon && iconPosition === 'after'" :class="[icon]"></i>
  </button>
</template>

<script setup lang="ts">
import { computed, type PropType } from "vue";

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
const props = defineProps({
  type: {
    type: String as PropType<"button" | "reset" | "submit">,
    default: "button",
  },
  color: {
    type: String,
    default: "", // 기본값: 'default', 'primary', 'secondary', 'none' 등
  },
  size: {
    type: String,
    default: "", // 기본값: 'sm', 'md', 'lg'
  },
  shape: {
    type: String,
    default: "", // circle
  },
  txt: {
    type: String,
    default: "text", // 기본값은 'text', 'none'이면 텍스트 없이 아이콘만 보임
  },
  iconPosition: {
    type: String,
    default: "before", // 기본값: 'before' 또는 'after'
  },
  icon: {
    type: String,
    default: "", // 아이콘 클래스 이름 (예: 'edit', 'delete', 'download' 등)
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

/* ------------------------------------------------------------
                          Computed Properties
   ------------------------------------------------------------ */
/** 버튼 클래스 */
const buttonClasses = computed(() => {
  return [
    "btn", // 기본 btn 클래스
    `btn_${props.color}`, // color prop에 따라 'btn_primary', 'btn_secondary' 등
    `btn_${props.size}`, // size prop에 따라 'btn_sm', 'btn_md', 'btn_lg' 등
    { btn_icon: props.icon }, // 아이콘이 있을 때만 btn_icon 클래스 추가
    { icon_only: props.txt === "none" }, // 텍스트가 없을 때만 icon_only 클래스 추가
    { btn_circle: props.shape === "circle" }, // 원형 버튼일 때만 btn_circle 클래스 추가
    { btn_round: props.shape === "round" }, // 양끝 반원 버튼일 때만 btn_circle 클래스 추가
  ];
});
</script>
